import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    "data-cy": "dialog-allocation-controller",
    class: "allocation-controller"
};
const _hoisted_2 = { class: "header body1-text" };
const _hoisted_3 = { class: "header__item" };
const _hoisted_4 = { class: "header__item" };
const _hoisted_5 = { class: "d-flex body text-center" };
import { computed, onBeforeUnmount, onMounted, } from 'vue';
import { mapControl, orderStatus, } from '@/constants';
import { i18n } from '@/locales';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { alertActionType } from '@/vuex-store/alert/actions';
import { hasSelectedOrdersInSelectedWorkerOrders, isImpossibleRequest, } from '@/lib/map-control/helper';
import OrderPolicy from '@/helpers/OrderPolicy';
import { toChar } from '@/utils';
import userPermission from '@/constants/userPermission';
import { allocationControllerActionType } from '@/vuex-store/allocation-controller/actions';
import { allocationControllerGetterType } from '@/vuex-store/allocation-controller/getters';
import { allocateWorkerType, shortcut, } from '@/constants/global';
const lc = 'views.dialog_allocation_controller.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AllocationController',
    setup(__props) {
        // 배차 컨트롤러 (목록관제, 지도관제 화면 하단)
        const { orderStatusGroup } = mapControl;
        const selectOrderMaxCount = mapControl.SELECT_ORDER_MAX_COUNT;
        const selectedOrderItemsObj = computed(() => vuexStore.state.allocationController.selectedOrderItemsObj);
        const selectedWorker = computed(() => vuexStore.state.allocationController.selectedWorker);
        const onCloseAction = computed(() => vuexStore.state.allocationController.onCloseAction);
        const selectedOrderList = computed(() => Object.values(selectedOrderItemsObj.value ?? []));
        const getterSelectedOrderCount = computed(() => selectedOrderList.value?.length);
        const getterUserPermission = computed(() => vuexStore.getters['user/getterUserPermission']);
        const getterIsOpenModalAllocate = computed(() => (vuexStore.getters[allocationControllerGetterType.getterIsOpenModalAllocate]));
        /**
         * 버튼 노출 조건
         */
        const isShowActionBtn = computed(() => {
            const workerCode = selectedWorker.value?.code;
            // 노출 조건
            const isShow = (
            // isHQ가 아닐 경우 노출
            !vuexStore.state.mapControl.isHQ
                // 배차 권한 유무
                && getterUserPermission.value([
                    userPermission.P_EXECUTE_ALLOCATE_WORKER,
                ])
                // 배달 클릭시
                && (selectedOrderList.value.length > 0)
                // 워커 클릭시
                && !!selectedWorker.value
                // 라이더가 퇴근 아닐 시
                && !selectedWorker.value.isTemporallyOff
                // 공유 라이더 아닐 시 => 공유 라이더에게는 배차할 수 없음
                && !selectedWorker.value.isShareWorker
                // 선택된 주문 중 선택된 라이더의 주문이 없을 경우
                && !hasSelectedOrdersInSelectedWorkerOrders(workerCode, selectedOrderList.value));
            return isShow;
        });
        /**
         * 선택된 주문 카운트
         */
        const getSelectedOrderItemsLength = computed(() => selectedOrderList.value.length ?? 0);
        /**
         * 접수 상태시 버튼 그룹
         * 모두 접수면 true
         */
        const acceptedTypeButtonGroup = computed(() => selectedOrderList.value.every(({ statusCode }) => (orderStatusGroup[statusCode] === orderStatus.ACCEPTED.code)));
        /**
         * 재배차 버튼 그룹
         */
        const allocatedTypeButtonGroup = computed(() => {
            if (acceptedTypeButtonGroup.value) {
                return false;
            }
            return selectedOrderList.value.every(({ statusCode }) => (orderStatusGroup[statusCode] !== orderStatus.ACCEPTED.code));
        });
        /**
         * 선택한 라이더 이름
         */
        const selectedWorkerName = computed(() => {
            try {
                return selectedWorker.value ? selectedWorker.value.user.name : '';
            }
            catch (error) {
                console.log('[selectedWorkerName]', error);
                return '';
            }
        });
        /**
         * 배차 관련 액션 (배차, 배차요청, 재배차)
         * @param allocateWorkerType 배차 종류
         */
        const actionAllocate = async (_allocateWorkerType) => {
            const workerCode = selectedWorker.value?.user.code;
            const orderList = Object.values(selectedOrderItemsObj.value);
            let result = [];
            try {
                result = await vuexStore.dispatch(allocationControllerActionType.allocateEvent, {
                    workerCode,
                    orderList,
                    allocateWorkerType: _allocateWorkerType,
                });
                result.forEach((item) => {
                    // 실패 시
                    if (item.isSuccess === false
                        || item.isError) {
                        vuexStore.dispatch(snackbarActionType.showError, item.message || i18n.t('common.failure'));
                        // 성공 시
                    }
                    else {
                        vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                    }
                });
                onCloseAction.value();
            }
            catch (error) {
                console.log(error);
                vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.failure'));
            }
        };
        /**
         * 재배차
         */
        const actionRealloate = async () => {
            if (!await vuexStore.dispatch(alertActionType.confirm, {
                headerTitle: i18n.t('common.reallocated'),
                bodyContentHtml: i18n.t(`${lc}confirm_reallocate`, [
                    selectedWorkerName.value,
                ]),
            })) {
                return;
            }
            actionAllocate(allocateWorkerType.REALLOCATE);
        };
        /**
         * 배차 및 재배차가 가능한 지 결과값 주는 메소드
         */
        const getAllocateAvailability = () => {
            const hasSelected = selectedOrderList.value.length > 0 // 배달 클릭시
                // 워커 선택시
                && !!selectedWorker.value
                // 퇴근 아닐 시
                && !selectedWorker.value.isTemporallyOff
                // 공유 라이더 아닐 시
                && !selectedWorker.value.isShareWorker
                // 선택된 주문 중 선택된 라이더의 주문이 없을 경우
                && !hasSelectedOrdersInSelectedWorkerOrders(selectedWorker.value.user.code, selectedOrderList.value);
            return hasSelected;
        };
        /**
         * 배차 요청 클릭 핸들러
         */
        const handleClickRequestAllocate = async () => {
            if (isImpossibleRequest(selectedOrderItemsObj.value)) {
                vuexStore.dispatch(snackbarActionType.showError, i18n.t(`${lc}impossible_request`));
                return;
            }
            actionAllocate(allocateWorkerType.REQUEST_ALLOCATE);
        };
        /**
         * 즉시 배차 클릭 핸들러
         */
        const handleClickAllocate = async () => {
            if (isImpossibleRequest(selectedOrderItemsObj.value)) {
                vuexStore.dispatch(snackbarActionType.showError, i18n.t(`${lc}impossible_request`));
                return;
            }
            actionAllocate(allocateWorkerType.IMMEDIATE);
        };
        /**
         * 재배차 클릭 핸들러
         */
        const handleClickReallocate = async () => {
            if (isImpossibleRequest(selectedOrderItemsObj.value)) {
                vuexStore.dispatch(snackbarActionType.showError, i18n.t(`${lc}impossible_request`));
                return;
            }
            actionRealloate();
        };
        /**
         * 선택 취소 클릭 핸들러
         */
        const handleClickCancelSelected = () => {
            onCloseAction.value();
        };
        /**
         * 취소 버튼 클릭 핸들러
         */
        const handleClickClose = () => {
            onCloseAction.value();
        };
        /**
         * 단축키 입력 이벤트 핸들러
         * @param event
         */
        const handleKeyUp = async (event) => {
            const pressedKey = event.which;
            // 특정 키 외 return
            if (![
                shortcut.cancel,
                shortcut.requestAllocate,
                shortcut.allocate,
                shortcut.reallocate,
            ].includes(pressedKey)) {
                return;
            }
            // 선택 취소
            if (pressedKey === shortcut.cancel) {
                onCloseAction.value();
                return;
            }
            // 가능여부 채크
            if (isImpossibleRequest(selectedOrderItemsObj.value)) {
                vuexStore.dispatch(snackbarActionType.showError, i18n.t(`${lc}impossible_request`));
                return;
            }
            // 배차요청 가능
            const isAllocateAvailable = getAllocateAvailability()
                && OrderPolicy.areAcceptedAvailable(Object.values(selectedOrderItemsObj.value));
            // 재배차요청 가능
            const isReallocateAvailable = getAllocateAvailability()
                && OrderPolicy.areReallocateAvailable(Object.values(selectedOrderItemsObj.value));
            // 배차 요청
            if (isAllocateAvailable && pressedKey === shortcut.requestAllocate) {
                // TODO 단축키 기능 버그 확인
                actionAllocate(allocateWorkerType.REQUEST_ALLOCATE);
            }
            // 즉시 배차
            if (isAllocateAvailable && pressedKey === shortcut.allocate) {
                actionAllocate(allocateWorkerType.IMMEDIATE);
            }
            // 재배차
            if (isReallocateAvailable && pressedKey === shortcut.reallocate) {
                actionRealloate();
            }
        };
        onMounted(() => {
            window.addEventListener('keyup', handleKeyUp);
        });
        onBeforeUnmount(() => {
            window.removeEventListener('keyup', handleKeyUp);
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_icon, {
                    "data-cy": "dialog-allocation-controller-close-btn",
                    class: "btn-modal-close",
                    color: "black",
                    onClick: handleClickClose
                }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode(" mdi-close ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [0]
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" 주문 "),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(lc + 'selected_order')), 1 /* TEXT */),
                        _createTextVNode(" " + _toDisplayString(getSelectedOrderItemsLength.value) + "/" + _toDisplayString(_unref(selectOrderMaxCount)), 1 /* TEXT */)
                    ]),
                    _createCommentVNode(" 라이더 "),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(lc + 'selected_worker')), 1 /* TEXT */),
                        _createTextVNode(" " + _toDisplayString(selectedWorkerName.value), 1 /* TEXT */)
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createCommentVNode(" 선택 취소 버튼 "),
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        class: "flex-grow-1 mx-1",
                        onClick: handleClickCancelSelected
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(lc + 'cancel_selected', [_unref(toChar)(_unref(shortcut).cancel)])), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })), [
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                info: true,
                                outlined: true,
                                "size-m": true
                            }
                        ]
                    ]),
                    _createCommentVNode(" 배차 요청 버튼 "),
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        class: "flex-grow-1 btn-allocate mx-1",
                        onClick: handleClickRequestAllocate
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(lc + 'request_worker', [getterSelectedOrderCount.value, _unref(toChar)(_unref(shortcut).requestAllocate)])), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })), [
                        [_vShow, isShowActionBtn.value && acceptedTypeButtonGroup.value],
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                primary: true,
                                "size-m": true
                            }
                        ]
                    ]),
                    _createCommentVNode(" 즉시 배차 버튼 "),
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        class: "flex-grow-1 mx-1 cy-btn-immeidate-allocate",
                        onClick: handleClickAllocate
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(lc + 'allocate', [getterSelectedOrderCount.value, _unref(toChar)(_unref(shortcut).allocate)])), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })), [
                        [_vShow, isShowActionBtn.value && acceptedTypeButtonGroup.value],
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                orange: true,
                                "size-m": true
                            }
                        ]
                    ]),
                    _createCommentVNode(" 재배차 버튼 "),
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        class: "flex-grow-1 btn-allocate mx-1",
                        onClick: handleClickReallocate
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(lc + 'reallocate', [getterSelectedOrderCount.value, _unref(toChar)(_unref(shortcut).reallocate)])), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })), [
                        [_vShow, isShowActionBtn.value && allocatedTypeButtonGroup.value],
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                primary: true,
                                "size-m": true
                            }
                        ]
                    ])
                ])
            ], 512 /* NEED_PATCH */)), [
                [_vShow, getterIsOpenModalAllocate.value]
            ]);
        };
    }
});
